export interface TitlePart {
	text: string;
	color: string;
}

export interface GatewayTheme {
	titleColor: string;
	titleParts?: TitlePart[];
	titlePartsDark?: TitlePart[];
	borderColor: string;
	borderColorDark?: string;
	toggleColor: string;
	cardBg: string;
}

export const GATEWAY_THEMES: Record<string, GatewayTheme> = {
	'abacate-pay': {
		titleColor: '#15803D',
		borderColor: '#22C55E',
		toggleColor: '#1ED015',
		cardBg: 'rgba(34, 197, 94, 0.1)',
	},
	stripe: {
		titleColor: '#4F46E5',
		borderColor: '#6366F1',
		toggleColor: '#4F46E5',
		cardBg: 'rgba(99, 102, 241, 0.1)',
	},
	pagarme: {
		titleColor: '#65A300',
		borderColor: '#84CC16',
		toggleColor: '#65A300',
		cardBg: 'rgba(101, 163, 0, 0.1)',
	},
	paypal: {
		titleColor: '#002C8A',
		titleParts: [
			{ text: 'Pay', color: '#002C8A' },
			{ text: 'Pal', color: '#009BE1' },
		],
		titlePartsDark: [
			{ text: 'Pay', color: '#5b9ef0' },
			{ text: 'Pal', color: '#29b6f6' },
		],
		borderColor: '#009BE1',
		toggleColor: '#009BE1',
		cardBg: 'rgba(0, 155, 225, 0.1)',
	},
	'mercado-pago': {
		titleColor: '#090080',
		titleParts: [
			{ text: 'Mercado ', color: '#090080' },
			{ text: 'Pago', color: '#00A1EA' },
		],
		titlePartsDark: [
			{ text: 'Mercado ', color: '#5b5bef' },
			{ text: 'Pago', color: '#29c5f6' },
		],
		borderColor: '#00A1EA',
		toggleColor: '#2F6AEA',
		cardBg: 'rgba(0, 161, 234, 0.1)',
	},
	pagseguro: {
		titleColor: 'var(--text-primary)',
		borderColor: 'var(--border)',
		borderColorDark: '#6b6b6b',
		toggleColor: 'var(--text-secondary)',
		cardBg: 'var(--bg-hover)',
	},
};

export const DEFAULT_GATEWAY_THEME: GatewayTheme = {
	titleColor: 'var(--text-primary)',
	borderColor: 'var(--border)',
	toggleColor: 'var(--primary)',
	cardBg: 'var(--bg-card)',
};

export const getGatewayTheme = (slug: string): GatewayTheme =>
	GATEWAY_THEMES[slug] ?? DEFAULT_GATEWAY_THEME;
